const styles = {
  root: {
    '& .MuiBreadcrumbs-li:nth-of-type(n+3)': {
      fontWeight: 600,
    },
    marginY: 0.5,
    paddingX: { xs: 2, lg: 0 },
    '& a': {
      textDecoration: 'none',
    },
    '& li': {
      fontSize: 10,
    },
    '&.inverted': {
      color: 'secondary.contrastText',
      '& li': {
        color: 'white',
      },
    },
    '& .MuiBreadcrumbs-ol': {
      overflow: { xs: 'hidden', lg: 'unset' },
      whiteSpace: { xs: 'nowrap', lg: 'unset' },
      textOverflow: { xs: 'ellipsis', lg: 'unset' },
      flexWrap: { xs: 'nowrap', lg: 'unset' },
    },
  },
  link: {
    textDecoration: 'none',
    '& .MuiTypography-root': {
      fontSize: 11,
    },
  },
}

export default styles
